var _circle, _path, _circle2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrailerError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15.5,
    r: 3,
    stroke: "#F59D0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C5.27614 15 5.5 14.7761 5.5 14.5C5.5 14.2239 5.27614 14 5 14V15ZM2 14C1.72386 14 1.5 14.2239 1.5 14.5C1.5 14.7761 1.72386 15 2 15V14ZM15 14C14.7239 14 14.5 14.2239 14.5 14.5C14.5 14.7761 14.7239 15 15 15V14ZM15.5 15C15.7761 15 16 14.7761 16 14.5C16 14.2239 15.7761 14 15.5 14V15ZM23 14C22.7239 14 22.5 14.2239 22.5 14.5C22.5 14.7761 22.7239 15 23 15V14ZM23.5 15C23.7761 15 24 14.7761 24 14.5C24 14.2239 23.7761 14 23.5 14V15ZM13.668 12.1274L13.3124 12.4788L13.668 12.1274ZM6.33196 12.1274L5.97629 11.7759L6.33196 12.1274ZM1.5 11.5V4H0.5V11.5H1.5ZM2 3.5H18V2.5H2V3.5ZM18.5 4V11.5H19.5V4H18.5ZM5.5 12H2V13H5.5V12ZM18 12H14.5V13H18V12ZM14.0237 11.7759C13.4145 11.1594 12.0073 10 10 10V11C11.6134 11 12.7781 11.938 13.3124 12.4788L14.0237 11.7759ZM10 10C7.99275 10 6.58545 11.1594 5.97629 11.7759L6.68762 12.4788C7.22193 11.9381 8.38657 11 10 11V10ZM5 14H2V15H5V14ZM15 15H15.5V14H15V15ZM23 15H23.5V14H23V15ZM14.5 12C14.3446 12 14.1708 11.9248 14.0237 11.7759L13.3124 12.4788C13.6078 12.7777 14.0259 13 14.5 13V12ZM5.5 13C5.97414 13 6.39223 12.7777 6.68762 12.4788L5.97629 11.7759C5.82922 11.9248 5.65538 12 5.5 12V13ZM18.5 11.5C18.5 11.7761 18.2761 12 18 12V13C18.8284 13 19.5 12.3284 19.5 11.5H18.5ZM18 3.5C18.2761 3.5 18.5 3.72386 18.5 4H19.5C19.5 3.17157 18.8284 2.5 18 2.5V3.5ZM1.5 4C1.5 3.72386 1.72386 3.5 2 3.5V2.5C1.17157 2.5 0.5 3.17157 0.5 4H1.5ZM0.5 11.5C0.5 12.3284 1.17157 13 2 13V12C1.72386 12 1.5 11.7761 1.5 11.5H0.5Z",
    fill: "#F59D0E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1429,
    cy: 19.1429,
    r: 4.65306,
    stroke: "#E82626",
    strokeWidth: 0.979592
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5501 17.0127L19.0229 20.2279C19.0237 20.2335 19.0318 20.2335 19.0326 20.2279L19.5054 17.0127C19.5483 16.7212 19.3224 16.4596 19.0278 16.4596C18.7331 16.4596 18.5072 16.7212 18.5501 17.0127Z",
    fill: "#E82626",
    stroke: "#E82626",
    strokeWidth: 0.979592
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4764 21.6164C19.4764 21.8634 19.2762 22.0636 19.0292 22.0636C18.7823 22.0636 18.582 21.8634 18.582 21.6164C18.582 21.3694 18.7823 21.1692 19.0292 21.1692C19.2762 21.1692 19.4764 21.3694 19.4764 21.6164Z",
    fill: "#E82626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerError);
export default __webpack_public_path__ + "static/media/TrailerError.5d44a2460f4970a46e6d3a320ba0e856.svg";
export { ForwardRef as ReactComponent };